import * as React from 'react'

function SvgIllustration403(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      viewBox="0 0 330 250"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      ref={svgRef}
      {...props}
    >
      <defs>
        <linearGradient
          x1="69.346%"
          y1="25.287%"
          x2="50%"
          y2="79.851%"
          id="illustration-403_svg__e"
        >
          <stop stopColor="#D6DAE1" stopOpacity={0.567} offset="0%" />
          <stop stopColor="#D6DAE1" stopOpacity={0} offset="100%" />
        </linearGradient>
        <linearGradient x1="50%" y1="0%" x2="50%" y2="79.851%" id="illustration-403_svg__f">
          <stop stopColor="#D6DAE1" stopOpacity={0.567} offset="3.996%" />
          <stop stopColor="#D6DAE1" stopOpacity={0} offset="100%" />
        </linearGradient>
        <ellipse id="illustration-403_svg__c" cx={105.746} cy={105.09} rx={105.746} ry={105.09} />
        <path id="illustration-403_svg__a" d="M0 0h330v250H0z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="illustration-403_svg__b" fill="#fff">
          <use xlinkHref="#illustration-403_svg__a" />
        </mask>
        <g mask="url(#illustration-403_svg__b)">
          <g transform="translate(59 3)">
            <mask id="illustration-403_svg__d" fill="#fff">
              <use xlinkHref="#illustration-403_svg__c" />
            </mask>
            <use fill="#F5F5F5" xlinkHref="#illustration-403_svg__c" />
            <g mask="url(#illustration-403_svg__d)">
              <path
                d="M70 0c10.493 0 19 8.507 19 19 0 2.91-.654 5.667-1.824 8.133A14.977 14.977 0 0193 39.116 17.171 17.171 0 0195 39c9.389 0 17 7.611 17 17 0 2.603-.585 5.07-1.63 7.275C117.847 66.93 123 74.614 123 83.5a22.42 22.42 0 01-5.94 15.232C131.531 103.398 142 116.976 142 133c0 19.882-16.118 36-36 36-17.335 0-31.808-12.252-35.232-28.569A22.421 22.421 0 0162.5 142C50.074 142 40 131.926 40 119.5c0-2.62.448-5.136 1.271-7.475A22.578 22.578 0 0131.788 104 22.411 22.411 0 0122.5 106C10.074 106 0 95.926 0 83.5c0-9.457 5.834-17.55 14.1-20.88-.067-.697-.1-1.405-.1-2.12 0-8.683 4.919-16.217 12.122-19.969A22.44 22.44 0 0125 33.5C25 21.074 35.074 11 47.5 11c1.723 0 3.4.194 5.013.56C55.407 4.764 62.147 0 70 0z"
                fill="url(#illustration-403_svg__e)"
                transform="translate(-15 67)"
              />
              <g fill="#FFF" fillRule="nonzero">
                <path d="M50.886 99.322V190h-2V99.322zM80.722 149.858a.7.7 0 01.556 1.284c-9.858 4.272-17.438 11.166-22.756 20.699a.7.7 0 11-1.223-.682c5.468-9.8 13.281-16.907 23.423-21.301zM80.722 125.858a.7.7 0 01.556 1.284c-9.858 4.272-17.438 11.166-22.756 20.699a.7.7 0 11-1.223-.682c5.468-9.8 13.281-16.907 23.423-21.301zM29.203 130.563a.7.7 0 01.984-.11c5.238 4.19 9.053 8.598 11.435 13.227a.7.7 0 11-1.244.64c-2.286-4.44-5.972-8.7-11.066-12.773a.7.7 0 01-.11-.984zM30.203 151.563a.7.7 0 01.984-.11c5.238 4.19 9.053 8.598 11.435 13.227a.7.7 0 11-1.244.64c-2.286-4.44-5.972-8.7-11.066-12.773a.7.7 0 01-.11-.984zM69.207 105.656a.5.5 0 11.497.867 71.05 71.05 0 00-.828.482l-.794.478c-5.833 3.565-8.85 6.744-9.084 9.458a.5.5 0 11-.996-.086c.234-2.714 2.68-5.623 7.317-8.782l.712-.476c.364-.239.74-.48 1.13-.72l.793-.486a70.85 70.85 0 011.253-.735zM31.749 105.656a.5.5 0 10-.498.867c.282.162.558.322.828.482l.794.478c5.833 3.565 8.85 6.744 9.084 9.458a.5.5 0 10.997-.086c-.235-2.714-2.68-5.623-7.317-8.782l-.712-.476c-.364-.239-.74-.48-1.13-.72l-.794-.486a70.85 70.85 0 00-1.252-.735z" />
              </g>
            </g>
            <g mask="url(#illustration-403_svg__d)">
              <path
                d="M36.923 0c8.61 0 15.59 6.98 15.59 15.59a15.53 15.53 0 01-1.497 6.674 12.283 12.283 0 014.778 9.833A13.773 13.773 0 0157.436 32c7.704 0 13.949 6.245 13.949 13.949 0 2.136-.48 4.16-1.339 5.969 6.138 3 10.364 9.304 10.364 16.595 0 4.82-1.848 9.21-4.874 12.498C87.41 84.839 96 95.981 96 109.128c0 16.314-13.225 29.539-29.538 29.539-16.314 0-29.539-13.225-29.539-29.539 0-3.435.587-6.734 1.665-9.8a18.496 18.496 0 01-10.044-7.431 18.394 18.394 0 01-7.62 1.641c-10.197 0-18.462-8.265-18.462-18.461 0-4.319 1.482-8.29 3.967-11.435A18.416 18.416 0 010 49.64a18.38 18.38 0 013.69-11.077A18.38 18.38 0 010 27.487C0 17.291 8.266 9.026 18.462 9.026c1.413 0 2.79.159 4.113.46C24.949 3.91 30.479 0 36.923 0z"
                fill="url(#illustration-403_svg__f)"
                transform="matrix(-1 0 0 1 211 108)"
              />
              <g fill="#FFF" fillRule="nonzero">
                <path d="M177.453 134.52v74.403h1.64V134.52zM152.972 175.986a.574.574 0 00-.457 1.054c8.09 3.505 14.308 9.161 18.672 16.983a.574.574 0 001.003-.56c-4.486-8.04-10.897-13.871-19.218-17.477zM152.972 156.294a.574.574 0 00-.457 1.054c8.09 3.505 14.308 9.161 18.672 16.983a.574.574 0 001.003-.56c-4.486-8.04-10.897-13.872-19.218-17.477zM195.244 160.154a.574.574 0 00-.807-.09c-4.299 3.439-7.429 7.055-9.384 10.853a.574.574 0 001.022.525c1.875-3.643 4.9-7.138 9.08-10.48a.574.574 0 00.089-.808zM194.423 177.385a.574.574 0 00-.807-.09c-4.298 3.438-7.428 7.055-9.383 10.852a.574.574 0 101.021.526c1.876-3.643 4.9-7.138 9.08-10.48a.574.574 0 00.09-.808zM162.42 139.718a.41.41 0 00-.408.711c.231.133.457.265.68.396l.651.392c4.786 2.925 7.261 5.533 7.453 7.76a.41.41 0 10.818-.07c-.192-2.227-2.2-4.614-6.004-7.206l-.584-.39a45.295 45.295 0 00-.927-.592l-.651-.398c-.333-.2-.675-.401-1.028-.603zM193.155 139.718a.41.41 0 11.408.711l-.68.396-.65.392c-4.787 2.925-7.262 5.533-7.454 7.76a.41.41 0 11-.818-.07c.192-2.227 2.2-4.614 6.004-7.206l.584-.39c.299-.197.608-.394.927-.592l.651-.398c.333-.2.675-.401 1.028-.603z" />
              </g>
            </g>
            <g mask="url(#illustration-403_svg__d)" fill="#FFF">
              <path d="M71 108h8v18h-8zM84 108h8v18h-8z" />
            </g>
            <g mask="url(#illustration-403_svg__d)">
              <g transform="translate(36.91 44.482)">
                <rect
                  stroke="#18263C"
                  strokeWidth={0.6}
                  fill="#FFF"
                  x={0.3}
                  y={0.3}
                  width={137.33}
                  height={109.371}
                  rx={2}
                />
                <path
                  d="M51.465 101.354c20.916-1.978 23.998-7.289 27.213-8.137 16.37-4.318 28.411-18.889 28.411-36.2 0-20.71-17.237-37.5-38.5-37.5s-38.5 16.79-38.5 37.5c0 17.637 12.5 32.43 29.341 36.433 1.369.326-.575 2.753-2.27 4.237-1.694 1.485-7.38 3.667-5.695 3.667z"
                  fill="#126BFB"
                />
                <path
                  d="M88.636 64.396l-5.415 8-.75.001v-8h6.165zm15.037-20.43c.475.904.758 1.925.794 3.009l.004.24v18.182a7 7 0 01-6.76 6.996l-.24.004H84.428l5.415-8h6.627v-4.592h-3.52l10.723-15.84zm-25.825-1.4c.55.592 1 1.265 1.332 2.018.4.897.6 1.858.6 2.883v17.17h.016c0 1.025-.2 1.986-.6 2.883-.399.897-.948 1.682-1.631 2.339a7.731 7.731 0 01-2.432 1.57 7.788 7.788 0 01-2.997.576H65.34a7.788 7.788 0 01-2.997-.577 7.731 7.731 0 01-2.432-1.57 7.799 7.799 0 01-.832-.96l8.26-11.58v4.052c0 .384.133.704.4.96.266.257.599.385.999.385s.732-.128.999-.384c.266-.257.4-.577.4-.961v-7.977l7.71-10.828zm-24.814-2.783L41.44 56.926h3.831v-4.687l8.191-12.234-.016 31.41h-8.175V64.87H31.55v-8.707l13.722-16.38h7.762zm18.157.602c1.053 0 2.041.192 2.963.576a7.882 7.882 0 012.371 1.535l-7.294 10.351v-1.84c0-.383-.131-.703-.395-.96a1.361 1.361 0 00-.988-.383c-.395 0-.724.128-.988.384a1.283 1.283 0 00-.395.96v5.76L58.02 68.733a6.82 6.82 0 01-.527-.96 7.056 7.056 0 01-.593-2.88v-17.15c0-1.024.197-1.984.593-2.88a7.394 7.394 0 011.613-2.336 7.636 7.636 0 012.404-1.567 7.632 7.632 0 012.964-.576h6.718zm26.28-.17a6.99 6.99 0 015.62 2.826L91.743 59.805l-9.272.001v-7h14v-4.591h-14v-8h15z"
                  fill="#FFF"
                  fillRule="nonzero"
                />
                <path
                  d="M135.93.3c.47 0 .894.19 1.202.498.308.308.498.733.498 1.202h0v8.836H.3V2c0-.47.19-.894.498-1.202A1.695 1.695 0 012 .3h0z"
                  stroke="#18263C"
                  strokeWidth={0.6}
                  fill="#FFF"
                />
                <ellipse fill="#D96156" cx={8.445} cy={5.568} rx={2.815} ry={2.784} />
                <ellipse fill="#F7B035" cx={16.889} cy={5.568} rx={2.815} ry={2.784} />
                <ellipse fill="#57BB52" cx={25.334} cy={5.568} rx={2.815} ry={2.784} />
              </g>
            </g>
          </g>
          <g strokeWidth={0.6}>
            <path
              stroke="#18263C"
              fill="#FFF"
              d="M259.455 235.164h7.266v4.008h-7.266zM240.825 235.164h7.266v4.008h-7.266z"
            />
            <path
              d="M267.237 237.637c.54 0 1.03.22 1.384.573a1.95 1.95 0 01.497 1.924 3.673 3.673 0 01-3.535 2.664h0-9.167a3.34 3.34 0 01-2.102-.744 3.34 3.34 0 01-1.168-1.9 2.074 2.074 0 01.287-1.566c.289-.447.748-.784 1.31-.905h0zM248.438 237.637c.54 0 1.03.22 1.384.573a1.95 1.95 0 01.497 1.924 3.673 3.673 0 01-3.535 2.664h0-9.167a3.34 3.34 0 01-2.103-.744 3.34 3.34 0 01-1.168-1.9 2.074 2.074 0 01.288-1.566c.289-.447.748-.784 1.31-.905h0z"
              stroke="#18263C"
              fill="#D6DAE1"
            />
            <path
              d="M235.715 130.561c-5.136 7.874-4.318 10.52-4.318 42.063 0 21.028 2.628 42.04 7.883 63.039h9.243c4.769-44.752 7.543-71.274 8.324-79.565.78-8.29 1.281-16.555 1.502-24.793-11.665-5.745-19.21-5.993-22.634-.744z"
              stroke="#1A1A1A"
              fill="#FFF"
            />
            <path
              d="M280.537 141c.594 11.731.306 24.977-.866 39.737-1.17 14.76-5.299 33.068-12.383 54.926h-8.226c-4.902-54.621-5.98-87.417-3.233-98.388 2.747-10.971 10.983-9.73 24.708 3.725z"
              stroke="#18263C"
              fill="#FFF"
            />
          </g>
        </g>
        <g mask="url(#illustration-403_svg__b)">
          <path
            d="M246.445 87.806l2.745-9.743h6.526l2.643 9.743c-2.89 2.068-5.021 3.102-6.393 3.102-1.372 0-3.212-1.034-5.521-3.102z"
            stroke="#18263C"
            strokeWidth={0.6}
            fill="#FFF"
          />
          <path
            d="M227.921 84c8.194-2.502 11.49-1.265 15.396 0 3.906 1.265 10.76 4.908 16.837 0 1.71-1.381 12.492-1.255 17.063 0 8.232 2.26 14.273 7.677 14.783 10.594V111.3c0 3.946-10.865-1.129-12.5-3.383 4.223 19.197 5.03 30.057 2.42 32.582l-53.999 1.234c-.746-16.305.397-28.354 3.428-36.148-4.284 3.61-8.318 5.081-12.1 4.416-2.498-.439-3.548-2.01-3.15-4.714l3.15-5.247-3.671-5.447c2.766-5.394 6.88-8.926 12.343-10.594z"
            stroke="#182333"
            strokeWidth={0.6}
            fill="#D6DAE1"
          />
          <path
            d="M289.119 97.888c1.818-2.44 2.879-3.46 3.182-3.06 1.089 1.435 2.768 2.89 3.268 2.65.903-.433 2.76-1.413 3.967-2.368 4.75-3.757 10.977-11.391 12.391-17.215 1.415-5.823 2.613-2.544 4.425-1.832 1.812.712 7.667.338 10.42 1.832 2.753 1.495-4.597 5.516-9.447 5.438-4.8 5.862-8.207 11.068-10.218 15.618-3.016 6.825-9.579 15.72-13.443 15.15-.85-.125-6.583-3.575-7.214-5.097-.853-2.054.005-5.707 2.573-10.957h0a1 1 0 01.096-.159zM218.605 97.888c-1.819-2.44-2.88-3.46-3.183-3.06-1.089 1.435-2.767 2.89-3.267 2.65-.904-.433-2.76-1.413-3.968-2.368-4.749-3.757-10.976-11.391-12.391-17.215-1.415-5.823-2.612-2.544-4.425-1.832-1.812.712-7.666.338-10.42 1.832-2.752 1.495 4.597 5.516 9.447 5.438 4.801 5.862 8.207 11.068 10.218 15.618 3.017 6.825 9.579 15.72 13.444 15.15.849-.125 6.582-3.575 7.214-5.097.852-2.054-.005-5.707-2.573-10.957h0a1 1 0 00-.096-.159z"
            stroke="#182333"
            strokeWidth={0.6}
            fill="#FFF"
          />
          <path
            d="M251.155 75.604c.974 1.146 1.949 1.146 2.923 0"
            stroke="#182333"
            strokeWidth={0.6}
            strokeLinecap="round"
          />
          <path
            d="M247.982 56.72c2.757-1.476 5.72-1.618 8.888-.424a9.83 9.83 0 016.315 10.173l-.568 5.704h-1.048l-20.18-.458c-1.582-7.993-.606-12.597 2.93-13.812.584-.165 1.092-.084 1.524.244l2.14-1.426z"
            fill="#182333"
          />
          <path
            d="M244.246 61.472c-1.085.753-1.879 4.221-2.382 10.404 1.737 4.798 4.372 7.69 7.905 8.678a10.03 10.03 0 0011.598-6.237c.55-1.459.826-2.706.826-3.742 0-3.861-.167-8.028-1.548-8.768-1.352-.724-11.513-3.92-14.078-1.934-.056.043-.594.282-.642.33-2.249 2.249-.051.14-1.679 1.27z"
            stroke="#18263C"
            strokeWidth={0.6}
            fill="#FFF"
          />
          <path
            d="M246.445 59.252c.993.972 1.75 1.65 2.267 2.036 4.187 3.124 11.152 4.667 14.085.5 1.144-1.625 1.982-6.21.522-4.617s-5.655-.654-7.29-.654c-3.537 0-6.732.912-9.584 2.735z"
            fill="#182333"
          />
          <path
            d="M249.769 59.816c-4.962 7.887-7.9 10.478-8.812 7.773-.674-2.001.49-5.35 4.708-7.465.831-.416 2.199-.519 4.104-.308zM260.487 62.69l1.119 9.62.87-.137-.87-10.016z"
            fill="#182333"
          />
          <path fill="#182333" d="M241.062 63.962l-.283 3.64.546 4.384 1.213.187V65.24z" />
        </g>
        <g mask="url(#illustration-403_svg__b)">
          <g transform="translate(59 13)">
            <circle stroke="#18263C" strokeWidth={0.6} fill="#FFF" cx={20} cy={20} r={19.7} />
            <path
              d="M19.314 20.632v1.423a.686.686 0 101.372 0v-1.423a1.49 1.49 0 10-1.372 0zm6.835-6.055h-1.371A4.783 4.783 0 0020 9.8a4.783 4.783 0 00-4.778 4.778h-1.37c0-1.642.639-3.186 1.8-4.348A6.109 6.109 0 0120 8.43c1.642 0 3.187.639 4.348 1.8a6.109 6.109 0 011.8 4.348zm.68 13.053H13.171a2.059 2.059 0 01-2.057-2.057V16.62c0-1.134.923-2.056 2.057-2.056h13.658c1.134 0 2.057.922 2.057 2.056v8.954a2.059 2.059 0 01-2.057 2.057zM13.171 15.934a.686.686 0 00-.686.685v8.954c0 .378.308.686.686.686h13.658a.686.686 0 00.686-.686V16.62a.686.686 0 00-.686-.685H13.171z"
              fill="#E59C1E"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgIllustration403)
const MemoForwardRef = React.memo(ForwardRef)
export default MemoForwardRef
